import { apiSlice } from "../../../shared/slices/apiSlice";
export const aiInterviewApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        checkAiInterviewInvitation: builder.query({
            query: (invitationId: string) => ({
                url: `interviews/ai/check?invitationId=${invitationId}`,
            }),
        }),
        uploadChunk: builder.mutation({
            query: ({ chunkIndex, chunk, interviewInvitationId }: { 
                chunkIndex: number; 
                chunk: Blob; 
                interviewInvitationId: number 
            }) => {
                const formData = new FormData();
                formData.append('chunkIndex', chunkIndex.toString());
                formData.append('chunk', chunk, `chunk-${chunkIndex}.webm`);
                formData.append('InterviewInvitationId', interviewInvitationId.toString());

                return {
                    url: 'ai-interviewer/upload-chunks',
                    method: 'POST',
                    body: formData,
                };
            },
        }),
        sendAiInterviewInvitation: builder.mutation({
            query: (data: { applicationId: number }) => ({
                url: `/interviews/ai/invite`,
                method: "POST",
                body: data
            }),
        }),
    })
})
   
export const { useCheckAiInterviewInvitationQuery, useSendAiInterviewInvitationMutation,useUploadChunkMutation } = aiInterviewApiSlice
